var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.patient_nationlity == 1)?_c('div',{staticClass:"badge bg-warning font-size-13"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('i',{staticClass:"mdi mdi-airplane-takeoff"})]):_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }